var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDopingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5338 14.9115C13.7847 13.8209 13.7503 12.7969 13.4875 12.1398C12.2299 8.9725 10.6049 8.59339 10.6915 7.93031C10.707 7.75208 10.7775 7.58327 10.893 7.44775C11.0085 7.31223 11.1632 7.21685 11.3352 7.1751L9.37868 6.61776L7.52516 5.77344C7.63048 5.91783 7.68829 6.09203 7.69043 6.27144C7.69258 6.45085 7.63895 6.62641 7.53711 6.77333C7.18612 7.34125 5.69555 6.57547 2.72186 8.1901C1.94222 8.61453 1.07296 9.71261 0.58158 11.1082C-0.329495 13.7107 0.0648061 17.3266 4.73369 19.556C10.2912 21.0211 12.8796 17.7405 13.5338 14.9115ZM1.6913 10.3968C3.78229 7.02859 7.17866 7.62672 7.67303 7.305C8.1674 6.98328 8.30182 6.22958 8.30182 6.22958L10.2674 6.95307C10.2674 6.95307 9.89396 7.61615 10.0687 8.18557C10.2435 8.755 13.2291 10.4965 12.6959 14.4342C12.1627 18.3718 8.52137 19.3838 5.05481 18.3764C1.75552 16.9007 -0.396706 13.7666 1.6913 10.3968Z",
    fill: "url(#paint0_linear_12007_12523)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96259 2.73047C6.69375 2.92531 6.42341 4.46292 6.52945 4.93568C6.76544 5.99297 11.7047 7.51396 12.3544 7.1862C12.8562 6.93396 13.5492 5.36313 13.5298 5.0837C13.5104 4.80427 6.96259 2.73047 6.96259 2.73047Z",
    fill: "url(#paint1_linear_12007_12523)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96072 2.73158C6.58883 3.27382 13.0664 6.09377 13.5324 5.08481C13.9984 4.07585 7.7792 1.53533 6.96072 2.73158Z",
    fill: "#EBC3D3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01051 3.05855C7.75511 3.43162 12.2343 5.21543 12.5539 4.52366C12.8736 3.83189 8.5706 2.23991 8.01051 3.05855Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64327 3.53753C7.03241 3.1267 6.9652 4.27612 7.11903 4.9981C7.27287 5.72008 11.5325 7.26373 12.227 6.53873C12.9215 5.81373 12.5048 5.7654 10.9082 5.11441C9.79431 4.64478 8.7046 4.11848 7.64327 3.53753Z",
    fill: "#9A376D"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M8.15344 3.84153C7.93986 3.69049 8.08324 5.0695 8.78969 5.8519C9.49615 6.63429 11.3855 6.30502 11.9262 5.54981C11.9217 5.55283 9.47823 4.50611 8.15344 3.84153Z",
    fill: "url(#paint2_linear_12007_12523)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5174 4.35582C9.17319 4.00238 11.2209 5.01285 11.9348 5.14577C12.6487 5.27868 13.521 5.23186 13.4956 5.03702C13.4776 4.91316 12.3157 4.74853 11.6122 4.62769C11.24 4.56997 10.8737 4.47899 10.5174 4.35582Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7945 6.36472C12.5974 6.23483 11.8222 6.74384 11.4339 6.91603C11.0456 7.08821 12.0716 7.23321 12.4689 6.98399C12.8662 6.73478 12.8961 6.43118 12.7945 6.36472Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17809 2.63019C6.96153 2.72987 7.0601 2.99571 7.34388 3.19055C7.62766 3.38539 7.58733 2.77821 7.48278 2.69815C7.38972 2.64653 7.28399 2.62295 7.17809 2.63019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64404 5.89405C7.16909 5.61916 7.51261 4.26582 7.7934 4.10723C8.07419 3.94864 9.40944 6.31697 9.09579 6.42119C8.78214 6.52541 7.64404 5.89405 7.64404 5.89405Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9069 3.19166C6.77696 3.32911 6.58279 4.26254 6.59474 4.68848C6.5881 4.81211 6.61491 4.93523 6.67228 5.04461C6.72964 5.15398 6.8154 5.24548 6.92034 5.30926C7.00846 5.37119 6.9293 4.28369 6.96365 3.77468C7.00995 3.08291 7.00995 3.08291 6.9069 3.19166Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61866 2.43187C7.12877 2.58291 6.93162 2.65239 8.6537 2.84572C10.3758 3.03905 12.1561 3.85015 12.4892 4.15374C12.8222 4.45733 12.5907 4.78963 13.3599 4.90895C14.1291 5.02827 12.5967 3.7278 10.5386 3.00733C8.48045 2.28686 7.61866 2.43187 7.61866 2.43187Z",
    fill: "#9A376D"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83789 3.6605C9.08851 2.5079 9.27895 1.34276 9.40843 0.169922C9.40843 0.169922 13.1095 0.265078 14.0564 2.61076C14.0564 2.61076 12.6375 3.58044 12.0804 4.76612C12.0819 4.76612 10.7317 4.70268 8.83789 3.6605Z",
    fill: "url(#paint3_linear_12007_12523)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9458 2.68968C12.7763 3.29838 8.8527 0.306245 9.47701 0.0887448C10.1013 -0.128755 10.9885 0.0781719 11.8324 0.442182C11.9128 0.550981 12.0145 0.641964 12.1311 0.709526C12.2394 0.743351 12.3523 0.760161 12.4656 0.75937L12.5493 0.806193C12.5493 0.806193 12.385 1.19588 12.8898 1.0101C13.889 1.63994 14.5133 2.39515 13.9458 2.68968Z",
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25977 3.87835C9.25977 3.87835 9.86765 1.27892 10.1858 1.06142C10.5039 0.843917 12.0975 0.99949 13.0848 1.54777C14.072 2.09605 14.0198 2.64584 14.0198 2.64584C13.911 2.37022 13.7406 2.12383 13.5219 1.92598C13.3032 1.72812 13.0421 1.5842 12.7592 1.50548C11.7585 1.19584 10.604 0.952667 10.3202 1.31064C10.0364 1.6686 9.5077 4.00069 9.5077 4.00069L9.25977 3.87835Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95703 4.20557C9.95703 4.20557 10.6456 2.10609 11.1384 1.76322C11.6313 1.42036 13.7313 2.75859 13.7313 2.75859C13.7313 2.75859 11.7657 1.68468 11.2654 1.84479C10.7651 2.00489 10.2961 4.32942 10.2961 4.32942L9.95703 4.20557Z",
    fill: "#B10053"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8809 4.51583C10.8809 4.51583 11.1796 3.22896 12.0921 3.0462C13.0047 2.86344 12.9569 3.55974 12.9569 3.55974L12.6791 3.86182C12.6791 3.86182 12.7374 3.1474 12.0548 3.22292C11.3722 3.29844 11.0093 4.55964 11.0093 4.55964L10.8809 4.51583Z",
    fill: "#B10053"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88281 2.52429C9.88281 2.52429 9.96347 1.38996 10.1815 1.06522C10.3996 0.740484 12.3771 1.39298 12.3771 1.39298C12.3771 1.39298 10.8835 1.00028 10.4026 1.24194C10.071 1.40205 9.88281 2.52429 9.88281 2.52429Z",
    fill: "#97001A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7539 2.67536C10.7539 2.67536 10.9585 1.78723 11.2737 1.71322C11.5888 1.63921 12.346 2.09385 12.346 2.09385C12.346 2.09385 11.5843 1.72229 11.2707 1.84463C10.957 1.96697 10.7539 2.67536 10.7539 2.67536Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65464 0.0966281C9.4097 0.0664197 9.92647 0.785378 10.0893 0.90017C10.2521 1.01496 10.9406 0.922826 11.2841 0.990795C11.6276 1.05876 10.0071 0.14043 9.65464 0.0966281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4668 1.2132C10.4668 1.2132 10.9731 1.7071 11.0642 1.71616C11.1553 1.72523 11.46 1.69049 11.6288 1.67991C11.7976 1.66934 11.351 1.09538 10.4668 1.2132Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3652 1.9043C11.8262 2.17095 12.3031 2.40854 12.7931 2.6157C13.28 2.78789 13.4607 2.76675 13.4607 2.76675C13.4607 2.76675 12.4824 1.91789 11.3652 1.9043Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1543 1.91351C11.2374 1.94491 11.3255 1.96078 11.4142 1.96033C11.5008 1.94522 11.5322 1.8395 11.5322 1.8395C11.4015 1.81771 11.2675 1.84397 11.1543 1.91351Z",
    fill: "#FFA457"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2598 1.3726C10.2598 1.3726 10.4659 1.41338 10.5196 1.3288C10.5734 1.24422 10.5286 1.2125 10.5286 1.2125C10.5286 1.2125 10.4091 1.1838 10.2598 1.3726Z",
    fill: "#FFA457"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 4.30741C10.3848 4.30741 10.8537 2.57345 11.0539 2.27137C11.254 1.96929 12.0994 2.40127 12.643 2.64595C13.1867 2.89064 12.543 2.6233 11.8753 3.03413C11.2077 3.44497 10.9224 4.34215 10.8119 4.40257C10.7014 4.46299 10.3848 4.30741 10.3848 4.30741Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4659 1.49621C10.3718 1.48262 9.85806 2.62299 9.75351 3.47788C9.64896 4.33278 10.0522 3.75731 10.1359 3.60476C10.2195 3.4522 10.7826 2.04601 10.8931 1.9146C11.0036 1.78319 10.4659 1.49621 10.4659 1.49621Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1017 1.04836C10.1361 0.969814 9.45948 0.494032 9.46247 0.52273C9.46545 0.551428 9.05024 3.00132 9.05472 3.30643C9.0592 3.61153 9.52818 2.37601 10.1017 1.04836Z",
    fill: "#D42F55"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 3.99457C11.2422 3.99457 11.5857 3.46139 11.9023 3.31337C11.9803 3.2682 12.0678 3.24221 12.1575 3.23749C12.2473 3.23276 12.3369 3.24945 12.4191 3.28618C12.4191 3.28618 12.2384 3.11249 11.8456 3.28618C11.4528 3.45988 11.2422 3.99457 11.2422 3.99457Z",
    fill: "#FF6500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4746 3.57401C10.4746 3.57401 10.8704 2.50766 10.9869 2.26297C11.1034 2.01828 11.1557 1.91406 11.1557 1.91406C11.1557 1.91406 10.8047 2.1663 10.4746 3.57401Z",
    fill: "#FF6500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5456 0.798828L12.6382 1.05258C12.6382 1.05258 12.4426 1.06164 12.5456 0.798828Z",
    fill: "#E23100"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 0.443359C12.0162 0.600016 12.2336 0.708946 12.4673 0.760547C12.3419 0.784661 12.2123 0.766727 12.098 0.709473C11.9837 0.652218 11.891 0.558777 11.834 0.443359Z",
    fill: "#E23100"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9426 2.42188C13.9434 2.51734 13.9308 2.61243 13.9052 2.70432C13.8578 2.75032 13.8079 2.79369 13.7559 2.83422C13.7559 2.83422 14.0083 2.65599 14.0202 2.64089C14.0014 2.56553 13.9753 2.49218 13.9426 2.42188Z",
    fill: "#97001A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93199 3.2207C8.93199 3.2207 8.91108 3.71914 10.3897 4.278C11.8683 4.83685 12.2178 4.50758 12.2178 4.50758L12.0819 4.76586C12.0819 4.76586 10.7048 4.72206 8.83789 3.66023L8.93199 3.2207Z",
    fill: "#D42F55"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.05516 18.3753C1.75438 16.8996 -0.397848 13.7655 1.69016 10.3958C2.14609 9.63947 2.76042 8.99346 3.4899 8.5032C5.33446 7.27523 7.30596 7.54409 7.67188 7.30393C8.16775 6.97919 8.30068 6.22852 8.30068 6.22852L10.2662 6.95201C10.2662 6.95201 9.89282 7.61508 10.0676 8.18451C10.202 8.62253 12.0092 9.76138 12.5842 12.0678C12.772 12.8416 12.8096 13.6449 12.6947 14.4331C12.1615 18.3738 8.52172 19.3827 5.05516 18.3753Z",
    fill: "url(#paint4_radial_12007_12523)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10547 6.99839C7.93141 7.06333 7.15177 7.64031 8.49747 8.59188C9.84317 9.54344 10.4645 8.71271 10.5885 8.06323C10.636 7.8661 10.7283 7.68285 10.8579 7.52793C10.9875 7.37302 11.1509 7.25068 11.3352 7.17057C11.3352 7.17057 9.60122 6.98177 7.52516 5.77344C7.52516 5.77344 7.8881 6.6374 7.10547 6.99839Z",
    fill: "#9A376D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1.3663 14.8555C1.3663 14.8555 -0.218374 12.4842 2.09068 9.73823C3.79782 7.70823 5.79173 7.65234 5.79173 7.65234C5.79173 7.65234 6.50864 7.8487 5.64238 10.5372C4.77611 13.2258 2.52979 15.3494 1.3663 14.8555Z",
    fill: "url(#paint5_linear_12007_12523)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54801 19.6381C-0.120876 17.4057 -0.516671 13.7898 0.39291 11.1934C0.333167 11.4139 -1.42924 16.8106 4.4808 19.3813C10.5178 22.0049 13.3436 14.989 13.3436 14.989C12.6954 17.8256 10.1041 21.1002 4.54801 19.6381Z",
    fill: "#9A376D"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91319 19.338C5.44869 18.9997 8.21029 19.0873 9.97419 18.4907C11.7381 17.894 9.47683 20.4935 5.91319 19.338Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6324 11.3709C12.3502 11.309 12.6937 12.8904 12.6324 13.9582C12.5712 15.0261 13.1656 14.3872 13.3434 13.6682C13.5211 12.9493 13.1193 11.4827 12.6324 11.3709Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74962 9.53685C1.23135 10.5488 3.4478 8.44633 4.15426 7.90107C4.86072 7.3558 2.589 7.892 1.74962 9.53685Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61672 7.81515C4.44944 7.73207 5.01102 7.41036 5.16934 7.46775C5.32766 7.52515 4.82881 7.91937 4.61672 7.81515Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0.635099 13.5205C0.213914 11.785 -0.149023 15.3677 1.54767 17.2089C3.24436 19.0501 5.10534 18.8839 5.26067 18.745C5.416 18.606 3.3743 17.8916 2.15854 16.7603C0.942773 15.629 0.635099 13.5205 0.635099 13.5205Z",
    fill: "#75FFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8534 8.80463C10.5143 8.75177 11.6913 9.81359 12.1722 10.6609C12.6531 11.5083 12.2708 9.58854 10.8534 8.80463Z",
    fill: "white"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18544 19.2429C3.58445 19.1099 0.431534 17.0044 1.1365 13.0924C1.28315 12.2194 1.61706 11.3893 2.11478 10.6607L7.16901 12.2557L11.8678 10.5625C12.3285 11.2112 12.6602 11.9443 12.8446 12.7209C13.7855 16.58 10.773 18.8834 7.18544 19.2429Z",
    fill: "url(#paint6_linear_12007_12523)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51367 11.7844C2.1111 10.6667 4.90108 12.5729 6.99655 15.2871C9.09202 18.0013 10.2316 15.852 11.0531 14.0999C11.8745 12.3478 11.7834 16.2477 10.6618 17.521C9.54009 18.7943 12.454 17.2763 12.9335 14.9971C13.4129 12.7179 11.8701 10.5625 11.8701 10.5625C11.8701 10.5625 12.4346 12.1409 11.4922 12.6106C10.5497 13.0804 6.20048 12.3433 4.50379 11.6832C2.8071 11.0232 2.11408 10.6607 2.11408 10.6607C1.87349 11.0117 1.67212 11.3886 1.51367 11.7844Z",
    fill: "#9A7AFF"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43469 10.4952C0.894829 10.459 4.92745 12.6068 9.1184 12.9119C13.3093 13.217 12.1444 10.7656 11.5649 10.178C10.9854 9.59048 7.01396 11.2187 5.27396 11.3864C3.53396 11.554 3.02316 10.5088 2.43469 10.4952Z",
    fill: "url(#paint7_linear_12007_12523)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04115 17.0578C0.398226 13.1458 6.30229 17.7299 8.25737 18.0561C10.2124 18.3824 11.0533 17.8643 11.0533 17.8643C11.0533 17.8643 8.76219 19.4986 6.3008 19.1693C3.8394 18.84 2.04115 17.0578 2.04115 17.0578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0332 14.1505C1.0332 14.1505 1.57537 19.2995 7.115 19.1228C12.6546 18.9461 13.0176 13.8711 13.0176 13.8711C13.0176 13.8711 13.3073 19.1742 7.19267 19.369C1.07801 19.5639 1.0332 14.1505 1.0332 14.1505Z",
    fill: "#9A3792"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27148 11.4492C3.27148 11.4492 5.30871 12.5397 8.45565 13.0231C11.6026 13.5064 12.0402 12.1168 12.0402 12.1168C12.0402 12.1168 11.2815 12.872 8.71702 12.721C6.15257 12.5699 3.27148 11.4492 3.27148 11.4492Z",
    fill: "#59C7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26461 12.8038C7.04805 12.6694 8.32803 12.6392 8.98072 12.8038C9.63341 12.9685 9.20625 13.1225 8.95384 13.0923C8.70142 13.0621 7.26461 12.8038 7.26461 12.8038Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74073 12.0778C4.22097 11.8784 6.77497 14.9037 7.99372 16.2118C9.21247 17.5198 10.2117 15.1635 10.7822 14.1108C11.0654 13.5619 11.4032 13.0437 11.7904 12.5641C11.7904 12.5641 10.2968 13.1773 8.70466 13.058C7.11251 12.9387 4.74073 12.0778 4.74073 12.0778Z",
    fill: "#9A7AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31626 12.6733C2.71447 11.2807 3.22527 14.1384 4.22596 15.8241C5.22665 17.5097 5.028 15.0794 6.01824 15.1806C7.00847 15.2818 6.97412 16.691 8.03754 17.4191C9.10095 18.1471 6.48722 18.8419 5.80914 17.9477C5.13106 17.0535 6.19896 17.0686 6.29903 17.2454C6.3991 17.4221 7.72837 18.1305 6.89645 16.7726C6.06454 15.4147 5.58809 16.2258 5.10417 17.055C4.62026 17.8843 3.46125 17.191 2.38589 14.8347C1.31052 12.4785 1.80041 11.1221 2.26789 11.0738C2.73538 11.0255 4.53065 12.1311 6.91736 12.8365C9.30408 13.5418 6.64703 14.1248 5.31626 12.6733Z",
    fill: "#9A7AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5148 12.9233C12.2422 12.1681 12.3766 11.5639 12.399 11.5141C12.4214 11.4642 13.4789 13.4353 12.7903 14.9654C12.1018 16.4954 11.7986 16.6873 11.6164 16.1994C11.4342 15.7115 11.948 13.5471 11.3505 13.5864C10.7531 13.6256 10.2274 15.9925 9.25955 16.1662C8.29172 16.3399 8.31711 14.8461 8.89661 14.0727C9.47612 13.2994 9.25656 14.5259 9.77931 14.2238C10.3021 13.9217 10.3588 13.2027 8.31562 13.1665C6.27242 13.1302 7.19992 14.6769 7.93924 14.0999C8.67855 13.5229 7.95716 15.6602 7.67637 15.707C7.39558 15.7538 6.91316 14.988 5.66006 13.5108C4.40696 12.0337 3.90811 12.088 3.43465 12.7345C2.96119 13.381 4.28897 15.639 3.52874 15.7432C2.76852 15.8475 1.93212 14.2026 1.86342 12.7481C1.79471 11.2936 1.80069 11.1622 2.11882 11.0791C2.43695 10.996 5.22693 12.7194 7.89145 12.9505C10.556 13.1816 11.5148 12.9233 11.5148 12.9233Z",
    fill: "#9A7AFF"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.196 9.78379C9.0011 9.58442 9.22813 11.8561 10.0735 13.075C10.9188 14.2939 11.9225 12.5207 11.7761 11.5646C11.6298 10.6085 10.5126 9.83666 10.196 9.78379Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83837 9.24844C6.07884 8.62011 4.77197 8.95995 4.55241 9.34964C4.33286 9.73933 5.6218 9.8224 5.83837 9.24844Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91767 11.928C1.5398 11.3737 1.07828 12.6545 1.27245 13.0593C1.46661 13.4641 2.25969 12.4325 1.91767 11.928Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33064 18.417C2.82065 17.2087 5.47471 17.3959 7.84948 17.8853C10.2242 18.3747 7.37303 19.2885 4.33064 18.417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06951 13.2344H1.27344",
    stroke: "url(#paint8_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71703 13.2344H3.8418",
    stroke: "url(#paint9_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73828 11.7285L5.15797 12.4626",
    stroke: "url(#paint10_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1582 15.5527L5.5779 16.2868",
    stroke: "url(#paint11_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47966 14.7795L6.03906 14.0077L6.47966 13.2344H7.36236L7.80296 14.0077L7.36236 14.7795H6.47966Z",
    stroke: "url(#paint12_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83513 11.7288L3.39453 10.9554L3.83513 10.1836H4.71783L5.15993 10.9554L4.71783 11.7288H3.83513Z",
    stroke: "url(#paint13_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1574 14.008L4.7168 13.2347L5.1574 12.4629H6.0401L6.4807 13.2347L6.0401 14.008H5.1574Z",
    stroke: "url(#paint14_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50896 14.008L2.06836 13.2347L2.50896 12.4629H3.39166L3.83226 13.2347L3.39166 14.008H2.50896Z",
    stroke: "url(#paint15_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50896 15.553L2.06836 14.7796L2.50896 14.0078H3.39166L3.83226 14.7796L3.39166 15.553H2.50896Z",
    stroke: "url(#paint16_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57732 17.8323L5.13672 17.0604L5.57732 16.2871H6.45852L6.90062 17.0604L6.45852 17.8323H5.57732Z",
    stroke: "url(#paint17_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27263 15.553L3.83203 14.7796L4.27263 14.0078H5.15533L5.59743 14.7796L5.15533 15.553H4.27263Z",
    stroke: "url(#paint18_linear_12007_12523)",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94347 12.6957L5.81055 12.4631L5.94347 12.2305H6.20784L6.34076 12.4631L6.20784 12.6957H5.94347Z",
    fill: "url(#paint19_linear_12007_12523)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22909 15.0125L7.09766 14.7799L7.22909 14.5488H7.49494L7.62787 14.7799L7.49494 15.0125H7.22909Z",
    fill: "url(#paint20_linear_12007_12523)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68176 13.4676L3.54883 13.235L3.68176 13.0039H3.94761L4.08054 13.235L3.94761 13.4676H3.68176Z",
    fill: "url(#paint21_linear_12007_12523)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41808 18.0648L5.28516 17.8322L5.41808 17.5996H5.68394L5.81687 17.8322L5.68394 18.0648H5.41808Z",
    fill: "url(#paint22_linear_12007_12523)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91027 15.0125L1.77734 14.7799L1.91027 14.5488H2.17613L2.30905 14.7799L2.17613 15.0125H1.91027Z",
    fill: "url(#paint23_linear_12007_12523)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 17.0605H7.7114",
    stroke: "url(#paint24_linear_12007_12523)",
    strokeMiterlimit: 10
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41016 15.2408L5.95749 12.8302L4.68199 12.1867L7.99471 10.4316L9.14177 13.7138L7.63178 13.5355L7.07318 16.4325L5.59007 15.7679L4.41016 15.2408Z",
    fill: "url(#paint25_linear_12007_12523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12007_12523",
    x1: 4.54051,
    y1: 19.4775,
    x2: 9.75927,
    y2: 6.5359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E5DDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DABBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D3A7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D19FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#BE92C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A57FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9272A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#886B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#846898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12007_12523",
    x1: 6.45966,
    y1: 3.96275,
    x2: 13.1259,
    y2: 6.35549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12007_12523",
    x1: 7.80272,
    y1: 4.67084,
    x2: 11.7383,
    y2: 6.08345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12007_12523",
    x1: 8.87078,
    y1: 1.69236,
    x2: 13.7635,
    y2: 3.44852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D83303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC5C11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12007_12523",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.71404 13.8648) rotate(20.1571) scale(6.49661 6.5526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E3DDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DBD1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D8CDD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D4C5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C7ACC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BE99C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B98FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78BC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12007_12523",
    x1: 1.44154,
    y1: 10.4681,
    x2: 5.19131,
    y2: 11.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12007_12523",
    x1: 7.15525,
    y1: 19.2581,
    x2: 6.89007,
    y2: 10.5175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4A9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6540FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12007_12523",
    x1: 2.11207,
    y1: 11.7637,
    x2: 12.1431,
    y2: 11.4661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12007_12523",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8AD90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12007_12523",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8AD90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12007_12523",
    x1: 4.94887,
    y1: 11.6908,
    x2: 4.94887,
    y2: 12.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12007_12523",
    x1: 5.3673,
    y1: 15.515,
    x2: 5.3673,
    y2: 16.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12007_12523",
    x1: 5.95244,
    y1: 14.0077,
    x2: 7.88959,
    y2: 14.0077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12007_12523",
    x1: 3.3079,
    y1: 10.9569,
    x2: 5.24506,
    y2: 10.9569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12007_12523",
    x1: 4.63017,
    y1: 13.2362,
    x2: 6.56732,
    y2: 13.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12007_12523",
    x1: 1.98173,
    y1: 13.2362,
    x2: 3.91889,
    y2: 13.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12007_12523",
    x1: 1.98173,
    y1: 14.7811,
    x2: 3.91889,
    y2: 14.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12007_12523",
    x1: 5.05009,
    y1: 17.0604,
    x2: 6.98725,
    y2: 17.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12007_12523",
    x1: 3.7454,
    y1: 14.7811,
    x2: 5.68256,
    y2: 14.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12007_12523",
    x1: 5.81055,
    y1: 12.4631,
    x2: 6.34076,
    y2: 12.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12007_12523",
    x1: 7.09616,
    y1: 14.7814,
    x2: 7.62787,
    y2: 14.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12007_12523",
    x1: 3.54883,
    y1: 13.2365,
    x2: 4.08054,
    y2: 13.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12007_12523",
    x1: 5.28516,
    y1: 17.8337,
    x2: 5.81687,
    y2: 17.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12007_12523",
    x1: 1.77734,
    y1: 14.7814,
    x2: 2.30905,
    y2: 14.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12007_12523",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8AD90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4CDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12007_12523",
    x1: 9.86466,
    y1: 5.48351,
    x2: 5.24328,
    y2: 16.9088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E0FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDopingIcon);
export default __webpack_public_path__ + "static/media/Doping_icon.c053b8d520b3fcb6c4e50aaf366041c1.svg";
export { ForwardRef as ReactComponent };